let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fliVL"), load("76n7a"), load("l253H"), load("gT4kI")]).then(() => parcelRequire('1XLXC'));